<template>
  <div class="league-details-container">
    <el-form class="user-from" label-width="120px" >
      <el-form-item v-if="setInfo" class="label-line-height" label="联赛Logo" >
        <el-upload
          :on-success="handleSuccess"
          :on-error="handleError"
          :before-upload="beforeAvatarUpload"
          :show-file-list="false"
          :data="dataObj"
          :action="qiniuUp"
          :accept="accept"
          class="upload-size"
          list-type="picture-card">
          <img v-if="setInfo.logo" :src="setInfo.logo | ImageFormats" >
          <i v-if="!setInfo.logo" class="el-icon-plus avatar-uploader-icon"/>
          <div slot="tip" class="el-upload__tip">只能上传图片，建议不超过5Mb</div>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img :src="dialogImageUrl" width="100%">
        </el-dialog>
      </el-form-item>
      <el-form-item label="联赛名称">
        <el-input
          v-model="setInfo.name"
          placeholder="请输入名称"/>
      </el-form-item>
      <el-form-item label="联赛类型">
        <el-select v-model="setInfo.gameType" placeholder="请选择">
          <el-option label="正常" value="正常"/>
          <el-option label="3v3" value="3v3"/>
          <el-option label="4v4" value="4v4"/>
        </el-select>
      </el-form-item>
      <el-form-item label="比赛类型">
        <el-select v-model="setInfo.type" placeholder="请选择">
          <el-option label="标准比赛" :value="0"/>
          <el-option label="小场地" :value="1"/>
        </el-select>
      </el-form-item>
      <el-form-item label="级别">
        <el-select v-model="setInfo.level" placeholder="请选择">
          <el-option label="国际" :value="0"/>
          <el-option label="国家" :value="1"/>
          <el-option label="市级" :value="2"/>
          <el-option label="区级" :value="3"/>
        </el-select>
      </el-form-item>
      <el-form-item
        label="起止日期">
        <el-date-picker
          v-model="setInfo.beginDate"
          type="date"
          placeholder="选择开始日期">
        </el-date-picker>
        <span>至</span>
        <el-date-picker
          v-model="setInfo.endDate"
          type="date"
          placeholder="选择结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="排序(倒序)" >
        <el-input
          v-model="setInfo.seq"
          type="Number"
          placeholder="请输入排序"/>
      </el-form-item>
      <el-form-item label="允许报名" >
        <el-radio-group v-model="setInfo.allowTeamSignup">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="允许运动员参加两支球队" >
        <el-switch
        v-model="playerTeamRestrictMode"
        active-color="#409EFF"
        inactive-color="#ccc">
        </el-switch>
        <el-checkbox-group v-model="checkList">
          <el-checkbox :disabled="!playerTeamRestrictMode" label="1" >男运动员(前锋和后卫)</el-checkbox>
          <el-checkbox :disabled="!playerTeamRestrictMode" label="2" >女运动员(前锋和后卫)</el-checkbox>
          <el-checkbox :disabled="!playerTeamRestrictMode" label="3" >男守门员</el-checkbox>
          <el-checkbox :disabled="!playerTeamRestrictMode" label="4" >女守门员</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="状态" >
        <el-radio-group v-model="setInfo.status">
          <el-radio :label="0">正常</el-radio>
          <el-radio :label="-1">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button :loading="userLoding" type="primary" @click="submitAction" >提交</el-button>
        <!--<el-button type="info" plain>返回</el-button>-->
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { varConfig, showMessage, ImageFormat, ConstConfig, getDateObjectByString } from '@/utils'
import { getQiniuUploadToken } from '@/api/site'
import { getMatchInfo, updateMatchInfo, createMatch } from '@/api/match'

export default {
  name: 'Details',
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      dataObj: { token: '' },
      qiniuUp: varConfig.qiniuUp,
      accept: ConstConfig.accept,
      setInfo: {
        logo: null,
        name: null,
        gameType: '正常',
        beginDate: null,
        endDate: null,
        seq: null,
        allowTeamSignup: 0,
        status: 0,
        type: 0,
        level: 2
      },
      userLoding: false,
      checkList: [],
      playerTeamRestrictMode: false,
      routerParams: {}
    }
  },
  created() {
    this.routerParams = this.$route.params
    if (this.routerParams.id) {
      this.getInfo()
    }
    this.getQiniuToken()
  },
  mounted() {},
  methods: {
    getInfo() {
      const params = { id: this.routerParams.id }
      getMatchInfo(params).then((resolve) => {
        if (!resolve.data) {
          return
        }
        const info = this.setInfo = resolve && resolve.data.match
        if (!info.playerTeamRestrictMode || info.playerTeamRestrictMode === 0 || info.playerTeamRestrictMode === '0') {
          this.playerTeamRestrictMode = false
        } else {
          this.checkList = info.playerTeamRestrictMode ? info.playerTeamRestrictMode.split('|') : []
          this.playerTeamRestrictMode = this.checkList.every((item) => {
            return item !== 0
          })
        }
        this.setInfo.beginDate = getDateObjectByString(this.setInfo.beginDate)
        this.setInfo.endDate = getDateObjectByString(this.setInfo.endDate)
    })
    },
    setMatchInfo() {
      this.userLoding = true
      this.setInfo.id = this.routerParams.id
      if (this.playerTeamRestrictMode === false) {
        this.setInfo.playerTeamRestrictMode = 0
      } else {
        if (this.checkList.length) {
          this.setInfo.playerTeamRestrictMode = this.checkList.join('|')
        } else {
          this.setInfo.playerTeamRestrictMode = 0
        }
      }
      updateMatchInfo(this.setInfo).then((resolve) => {
        this.userLoding = false
        if (!resolve) {
          return
        }
        this.$message({
          message: '更新成功',
          type: 'success'
        })
      }, (reject) => {
        this.userLoding = false
        this.$message.error('数据保存失败')
      })
    },
    handleSuccess(response) {
      this.setInfo.logo = response.hash
    },
    handleError(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        showMessage('error', '上传头像图片大小不能超过 10MB!')
      }
      return isLt2M
    },
    getQiniuToken() {
      getQiniuUploadToken().then(response => {
        const data = response.data
        this.dataObj.token = data.token
      }).catch(err => {
        console.log(err, 'error', '七牛Token获取失败')
      })
    },
    submitAction() {
      if(this.routerParams && this.routerParams.id) {
        this.setMatchInfo()
      }else{
        this.newMatch()
      }
    },
    newMatch() {
      this.userLoding = true
      if (this.playerTeamRestrictMode) {
        this.setInfo.playerTeamRestrictMode = this.checkList.join('|')
      } else {
        this.setInfo.playerTeamRestrictMode = 0
      }
      createMatch(this.setInfo).then((res) => {
        this.userLoding = false

        if (!res) {
          return
        }
        const data = res.data;
        if(data && data.match) {
          this.$message({
            message: '创建成功',
            type: 'success'
          })
          this.$router.push({
            path:`/league/details/${data.match.id}`
          })
        }
      })
    }
  },
  filters: {
    ImageFormats(img) {
      return ImageFormat.squareImageView(img, 156)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
  .league-details-container {
    margin: 30px 15px;
    .action-header {
      padding: 0 10px 10px 10px;
    }
    .el-table {
      th {
        div {
          line-height: 20px;
        }
        .el-select {
          padding-left: 0;
          padding-right: 0;
          .el-input {
            padding-left: 0;
            padding-right: 0;
          }
        }
      }
    }

    .table-footer {
      text-align: center;
      margin-top: 30px;
    }

    .upload-size .el-upload {
      width: 80px;
      height: 80px;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 78px;
      height: 78px;
      line-height: 78px !important;
      text-align: center;
      position: absolute;
      top: 0;
      left: 0;
    }

    .upload-size .el-upload:hover {
      border-color: #409EFF;
    }

    .upload-size .el-upload-list li {
      width: 80px;
      height: 80px;
    }

    .user-from .el-form-item__label {
      text-align: left;
      padding-left: 15px;
    }

    .certificate-upload-style {
      width: 120px;
      height: 32px;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      color: #999999;
      line-height: 32px;
    }

    .font-size-style {
      font-size: 14px;
      color: #169BD5;
      padding-left: 20px;
    }

    .team-info-width {
      width: auto;
      margin-right: 12px;
    }

    .el-upload img {
      width: 78px;
      height: 78px;
    }
  }
</style>
